import { useCookies } from 'vue3-cookies'

import { getConfig } from '@/common/config'
import * as consts from '@/common/consts'

const vueCookies = useCookies()

/**
 * Configure OAuth2 cookie settings
 */
export function config(): void {
  const cookiePath = getConfig()?.oauth2?.cookiePath || '/'
  vueCookies.cookies.config({
    expireTimes: 0,
    path: cookiePath
  })
  console.log('vue cookies configured.', cookiePath)
}

/**
 * Set authentication cookie.
 * @param isAuthenticated - Authentication flag value
 * @param persistent - When true, cookie survives browser restart (Max-Age). When false, session cookie.
 */
export function set(isAuthenticated: string | boolean, persistent?: boolean): void {
  if (persistent) {
    vueCookies.cookies.set(consts.COOKIE_NAME_AUTHENTICATED, String(isAuthenticated), 7 * 86400)
  } else {
    vueCookies.cookies.set(consts.COOKIE_NAME_AUTHENTICATED, String(isAuthenticated))
  }
}

/**
 * Clear authentication cookie
 */
export function clear(): void {
  vueCookies.cookies.remove(consts.COOKIE_NAME_AUTHENTICATED)
}

/**
 * Check if authentication cookie is valid
 * @returns Cookie value or false if not set
 */
export function isValid(): string | boolean {
  const flag = vueCookies.cookies.get(consts.COOKIE_NAME_AUTHENTICATED) || false
  console.log('Cookie valid: ', flag)
  return flag
}
